'use client';

import { AppImageClient } from '@components/appImage';

import type { RadarApiMedia } from '../constants';

import { Button } from '@/shared/components/button';
import { useCurrentLocale, useGetClientHost } from '@/shared/hooks';
import { TranslatedComponent } from '@/shared/types';
import { getDocsUrl } from '@/shared/utils/getDocsUrl';
import { getDomainKey } from '@/shared/utils/getDomainInfo';

interface Props extends TranslatedComponent {
  /** Иллюстрация по доменам, данные AppImage с сервера */
  images: RadarApiMedia;
}

export const RadarApiSection = ({ translations, images }: Props) => {
  const domain = getDomainKey(useGetClientHost());
  const locale = useCurrentLocale();
  const image = images[domain];
  const docsHref = getDocsUrl('/api/navigation/radar/overview', locale);

  return (
    <>
      {/** Desktop версия */}
      <div className="hidden min-h-[319px] justify-between md:flex">
        <div className="flex h-full max-w-[668px] flex-col justify-between gap-9 pt-[30px]">
          <div className="flex flex-col gap-5">
            <h4 className="text-[44px] leading-[52px] font-medium tracking-[-0.44px]">
              {translations.radarApiSectionTitle}
            </h4>
            <p className="text-[16px] leading-[24px] font-normal tracking-[-0.16px]">
              {translations.radarApiSectionDescription}
            </p>
          </div>
          <Button
            target="_blank"
            href={docsHref}
            variant="secondary"
            className="size-fit px-6 py-4"
          >
            {translations.buttonMoreDetails}
          </Button>
        </div>
        <AppImageClient
          {...image}
          alt="radar-api"
          className="rounded-20 mr-[-34px] size-full h-[326px] w-auto max-w-[390px]"
        />
      </div>

      {/** Мобильная версия */}
      <div className="flex h-auto flex-col gap-9 md:hidden">
        <div className="flex flex-col gap-3">
          <h4 className="text-[30px] leading-[38px] font-medium tracking-[-0.3px]">
            {translations.radarApiSectionTitle}
          </h4>
          <p className="text-[16px] leading-[24px] font-normal tracking-[-0.16px]">
            {translations.radarApiSectionDescription}
          </p>
        </div>
        <AppImageClient
          {...image}
          alt="radar-api"
          className="h-[287px] w-auto object-contain"
        />
        <Button
          target="_blank"
          href={docsHref}
          variant="secondary"
          className="mt-1 w-full items-center justify-center px-4 py-3"
        >
          {translations.buttonMoreDetails}
        </Button>
      </div>
    </>
  );
};
